import { render, staticRenderFns } from "./GuestImage.vue?vue&type=template&id=12578f06"
import script from "./GuestImage.vue?vue&type=script&lang=js"
export * from "./GuestImage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports